<template>
    <h3 ref="subTable">
        <div class="controlling-for" v-if="selectionModel.v.control1.include">
            <div>
                <div class="pre-label">Controlling for</div>
                <div class="variables">
                    <div>
                        <span style="text-align: right">{{
                            selectionModel.v.control1.variable.toString()
                        }}</span>
                        <span>=</span>
                        <span style="text-align: left">{{
                            control1.control1Level.title
                        }}</span>
                    </div>
                    <div v-if="reportModel.parms.control2 !== null">
                        <span style="text-align: right">{{
                            reportModel.parms.control2.groupToString()
                        }}</span>
                        <span>=</span>
                        <span style="text-align: left">{{
                            control2.control2Level.title
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </h3>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import commonModelHelper from '@/scripts/commonModelHelper';
import current from '@/scripts/current';
import store from '@/store';
import common from '@/scripts/common';

export default {
    props: ['reportModel', 'control1', 'control2'],
    data: function () {
        var vm = this;
        return {
            years: commonModelHelper.getDisplayYearsWithAnd(),
            rowsAndColumns: vm.getRowsAndColumns(),
            variableSelectionHelper: variableSelectionHelper,
            selectionModel: current.selectionModel,
            key: common.getCtKeyFromControls(vm.control1, vm.control2)
        };
    },
    mounted: function () {
        const vm = this;
        //We are only setting width
        store.dispatch('loadedControls/mounted', {
            name: 'crosstabTitle',
            control1: vm.control1,
            control2: vm.control2,
            vm,
            subTable: vm.$refs.subTable
        });
    },
    methods: {
        setWidth: function (newWidth) {},
        getRowsAndColumns: function () {
            var vm = this;
            //var theRow =
            return (
                ' of ' +
                vm.reportModel.parms.row.groupToString() +
                (vm.reportModel.parms.column === null
                    ? ''
                    : ' by ' + vm.reportModel.parms.column.groupToString())
            );
        }
    }
};
</script>

<style scoped>
h3 {
    display: block;
    font-size: 19px;
    -webkit-margin-before: 0.67em;
    margin-block-start: 0.67em;
    -webkit-margin-after: 0.67em;
    margin-block-end: 0.67em;
    -webkit-margin-start: 0px;
    margin-inline-start: 0px;
    -webkit-margin-end: 0px;
    margin-inline-end: 0px;
    font-weight: 400;
    color: black;
    background-color: inherit;
}

h3 {
    text-align: center;
    margin: 0 0 0 0;
    overflow: auto;
}
h3 div.row {
    font-size: 18px;
    line-height: 24px;
    vertical-align: middle;
}

h3,
.well {
    min-height: 20px;
    padding: 19px;

    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
    box-sizing: border-box;
}
.controlling-for span {
    font-size: 16px;
    line-height: 21px;
}

@media (min-width: 768px) {
    h3,
    .well {
        margin: 0 10px 20px 10px;
    }
}

.pre-label {
    width: 100%;
    float: left;
    text-align: left;
    overflow: auto;
}
.variables {
    width: 100%;
    float: left;
    overflow: auto;
    text-align: left;
}

@media (min-width: 768px) {
    .variables {
        width: 90%;
        padding-left: 10%;
    }
}
/* @media (max-width: 991px) {
} */

/* @media (min-width: 768px) {
  .pre-label {
    width: 100%;
  }
} */
@media (min-width: 992px) {
    .pre-label {
        width: 14%;
        float: left;
        text-align: right;
    }
    .variables {
        width: 81%;
        padding-left: 5%;
    }
}
@media (min-width: 1200px) {
    .pre-label {
        width: 15%;
    }
    .variables {
        width: 82%;
        padding-left: 3%;
    }
}
</style>
